// IE9 don't implement it
if(!("requestAnimationFrame" in window)){
	if("webkitRequestAnimationFrame" in window){
		window.requestAnimationFrame = window.webkitRequestAnimationFrame;
	}else{
		// https://gist.github.com/paulirish/1579671
		// TODO Use a queue instead of a setTimeout call each times (see gist comments)
		(function requestAnimationFrameClosure(){
			var lastTime = 0;
			window.requestAnimationFrame = function requestAnimationFrame(callback, element) {
				var currTime = Date.now();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				lastTime = currTime + timeToCall;
				return window.setTimeout(function requestAnimationFrameCallbackWrapper(){
					callback(currTime + timeToCall);
				}, timeToCall);
			};
		})();
	}
}